export default { options: { label: 'kinds' } }
